import {
    processAccessControlError,
    setAccessControlError,
    setAccessControlPermission,
} from "actions/access-control-actions";
import { ACCESS_CONTROL } from "constants/action-types";
import me from "models/me";
import { Observable } from "rxjs/Observable";
import { ASSORTMENT_PAGE, BRAND_PAGE, FALLBACK_PAGE } from "helpers/access-control";
import { replace } from "react-router-redux";

export const manageAccessControlEpic = (action$, store) =>
    action$
        .ofType(ACCESS_CONTROL.ERROR.PROCESS)
        .throttle(() => Observable.timer(500))
        .flatMap((action: ReturnType<typeof processAccessControlError>) => {
            const actions = [];

            if (me?.isBuyer()) {
                me.save({ last_brand: null }, { patch: true });
                actions.push(setAccessControlPermission(false));

                const pathname = store.getState().routing?.locationBeforeTransitions?.pathname;
                const canShowTheAccessRevokedModal =
                    pathname?.includes(BRAND_PAGE) && !pathname?.includes(ASSORTMENT_PAGE);
                const canRedirectTheUserToTheFallbackPage =
                    !pathname?.includes(FALLBACK_PAGE) && !pathname?.includes(ASSORTMENT_PAGE);

                if (canShowTheAccessRevokedModal) {
                    actions.push(setAccessControlError(action.payload));
                }

                if (canRedirectTheUserToTheFallbackPage) {
                    actions.push(replace(FALLBACK_PAGE));
                }
            }

            return actions;
        });
